import React, { useState, useEffect } from 'react';
import { Helix2000Character } from '../../../../../shared/CharacterTypes';
import { GameConstants } from '../../../../../shared/GameConstants';
import { storage } from '../../../../services/StorageService';
import { buttonStyle, inputStyle, sectionHeaderStyle } from './styles';

interface PhysicsProfilesProps {
  player: Helix2000Character;
  onRefresh: () => void;
}

export const PhysicsProfiles: React.FC<PhysicsProfilesProps> = ({ player, onRefresh }) => {
  const [profiles, setProfiles] = useState<Record<string, any>>({});
  const [currentProfileName, setCurrentProfileName] = useState('');

  useEffect(() => {
    const savedProfiles = storage.getObject<Record<string, any>>('helix_physics_profiles');
    if (savedProfiles) setProfiles(savedProfiles);
  }, []);

  const saveProfile = () => {
    if (!currentProfileName.trim() || !player) return;
    const newProfiles = {
      ...profiles,
      [currentProfileName]: {
        constants: { ...GameConstants.Physics },
        stats: { ...player.movementStats }
      }
    };
    setProfiles(newProfiles);
    storage.setObject('helix_physics_profiles', newProfiles);
    setCurrentProfileName('');
  };

  const loadProfile = (name: string) => {
    const profile = profiles[name];
    if (!profile || !player) return;
    Object.assign(GameConstants.Physics, profile.constants);
    if (player.movementStats) Object.assign(player.movementStats, profile.stats);
    onRefresh();
  };

  const deleteProfile = (name: string) => {
    const newProfiles = { ...profiles };
    delete newProfiles[name];
    setProfiles(newProfiles);
    storage.setObject('helix_physics_profiles', newProfiles);
  };

  return (
    <>
      <div style={sectionHeaderStyle}>Physics Profiles</div>
      <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
        <input
          placeholder="Profile Name"
          style={{ ...inputStyle, flex: 1, marginBottom: 0 }}
          value={currentProfileName}
          onChange={(e) => setCurrentProfileName(e.target.value)}
          onKeyDown={(e) => e.stopPropagation()}
        />
        <button
          style={{ ...buttonStyle, marginBottom: 0, padding: '5px 10px', background: '#27ae60' }}
          onClick={saveProfile}
        >
          Save
        </button>
      </div>

      <div style={{ maxHeight: '150px', overflowY: 'auto', background: 'rgba(0,0,0,0.2)', padding: '5px', borderRadius: '5px' }}>
        {Object.keys(profiles).length === 0 ? (
          <div style={{ fontSize: '11px', color: '#666', textAlign: 'center' }}>No saved profiles</div>
        ) : (
          Object.keys(profiles).map(name => (
            <div key={name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
              <span style={{ fontSize: '11px', color: '#eee' }}>{name}</span>
              <div style={{ display: 'flex', gap: '5px' }}>
                <button
                  style={{ ...buttonStyle, display: 'inline', width: 'auto', padding: '2px 6px', fontSize: '10px', background: '#2980b9' }}
                  onClick={() => loadProfile(name)}
                >
                  Load
                </button>
                <button
                  style={{ ...buttonStyle, display: 'inline', width: 'auto', padding: '2px 6px', fontSize: '10px', background: '#e74c3c' }}
                  onClick={() => deleteProfile(name)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};
